import { render } from "./register-step-five.vue?vue&type=template&id=637f7de4"
import script from "./register-step-five.vue?vue&type=script&lang=js"
export * from "./register-step-five.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__